import images from "./images";

const accommodations = [
    {
        id: 1,
        image: images.accommodation1,
        title: "Tents",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Adventure Campground",
            peopleCapacity: "4 People",
            size: "20 sqm",
            wifi: "Yes",
            bedrooms: "2 bedrooms",
            reservationCost: "From $120 per night"
        },
        paragraphs: [
            "Experience the thrill of camping in stunning natural settings with our Tent Accommodation. Discover the joy of sleeping under the stars, perfect for nature enthusiasts and adventure seekers.",
            "Our tent accommodation offers a variety of camping options for all levels of campers. Whether you're a beginner or an experienced outdoorsman, our tents provide the perfect setting for a memorable outdoor adventure."
        ],
        gallery: [
            images.accommodation1Gallery1,
            images.accommodation1Gallery2
        ],
        features: [
            "Comfortable sleeping arrangements",
            "Portable lighting and power options",
            "Access to clean restroom and shower facilities",
            "Outdoor cooking equipment provided",
            "Scenic and spacious tent sites"
        ],
        facilities: [
            "Guided tours for all skill levels",
            "Flexible scheduling for busy campers",
            "Well-marked and maintained trails",
            "Indoor and outdoor rest areas",
            "Complimentary water and snacks",
            "Scenery that includes forests, mountains, and lakes",
            "Professional guides with first aid training",
            "Group and solo camping options",
            "Shuttle services to and from trailheads",
            "Rental gear available on request"
        ]
    },
    {
        id: 2,
        image: images.accommodation2,
        title: "Cabins",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Mountain Retreat",
            peopleCapacity: "6 People",
            size: "50 sqm",
            wifi: "Yes",
            bedrooms: "3 bedrooms",
            reservationCost: "From $200 per night"
        },
        paragraphs: [
            "Enjoy the comfort and warmth of our Cabin Accommodation, nestled in serene natural surroundings. Perfect for families and groups looking for a cozy escape.",
            "Our cabins provide all the comforts of home, with spacious interiors and modern amenities, allowing you to enjoy the outdoors while having all the conveniences you need."
        ],
        gallery: [
            images.accommodation2Gallery1,
            images.accommodation2Gallery2
        ],
        features: [
            "Fully furnished living space",
            "Wood-burning stove for warmth",
            "Equipped kitchen for self-catering",
            "Private outdoor deck with seating",
            "Scenic views of mountains and forest"
        ],
        facilities: [
            "Hiking trails right outside the door",
            "Private parking for each cabin",
            "Pets allowed in certain cabins",
            "Comprehensive guest services",
            "Outdoor BBQ area",
            "Fishing and boating opportunities nearby",
            "Group activities available",
            "Guided wildlife tours",
            "Well-maintained cabins with modern amenities",
            "Rental bikes and outdoor gear available"
        ]
    },
    {
        id: 3,
        image: images.accommodation3,
        title: "Lodges",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Secluded Lodge Resort",
            peopleCapacity: "8 People",
            size: "100 sqm",
            wifi: "Yes",
            bedrooms: "4 bedrooms",
            reservationCost: "From $300 per night"
        },
        paragraphs: [
            "Experience the ultimate comfort in our spacious Lodge Accommodation, perfect for larger groups or families seeking a luxurious getaway.",
            "Our lodges offer expansive living spaces, with all the modern amenities for a comfortable and relaxing stay in a tranquil environment, surrounded by breathtaking nature."
        ],
        gallery: [
            images.accommodation3Gallery1,
            images.accommodation3Gallery2
        ],
        features: [
            "Spacious living and dining areas",
            "Fully equipped kitchen and bathrooms",
            "Private balcony with scenic views",
            "Wood-burning fireplace for cozy nights",
            "Luxurious furnishings and decor"
        ],
        facilities: [
            "Access to private nature trails",
            "Indoor and outdoor event spaces",
            "Exclusive spa and wellness center",
            "Heated swimming pool",
            "Daily housekeeping and concierge services",
            "Nearby hiking, fishing, and adventure activities",
            "Pet-friendly options available",
            "Premium outdoor BBQ grills",
            "24/7 room service",
            "Luxury linens and toiletries"
        ]
    },
    {
        id: 4,
        image: images.accommodation4,
        title: "Tree Houses",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Forest Canopy Retreat",
            peopleCapacity: "4 People",
            size: "30 sqm",
            wifi: "Yes",
            bedrooms: "1 bedroom",
            reservationCost: "From $250 per night"
        },
        paragraphs: [
            "Escape to the treetops with our unique Tree House Accommodation, offering an unforgettable experience immersed in nature's beauty. Perfect for couples or small groups seeking a serene retreat.",
            "Our tree houses are designed to provide a perfect blend of adventure and comfort, with stunning views and eco-friendly amenities that allow you to enjoy nature without compromising on luxury."
        ],
        gallery: [
            images.accommodation4Gallery1,
            images.accommodation4Gallery2
        ],
        features: [
            "Elevated treehouse with panoramic views",
            "Eco-friendly construction and design",
            "Private deck with seating and a hammock",
            "Cozy, comfortable interiors with nature-inspired decor",
            "Fully functional kitchenette"
        ],
        facilities: [
            "Access to nature trails and observation points",
            "Birdwatching and wildlife spotting opportunities",
            "Complimentary breakfast delivered to your tree house",
            "Shuttle service to nearby attractions",
            "Private outdoor fire pit for cozy nights",
            "Exclusive forest experiences and guided tours",
            "Private and secluded location",
            "Eco-conscious and sustainable amenities",
            "Yoga and meditation sessions in nature",
            "On-demand concierge services"
        ]
    },
    {
        id: 5,
        image: images.accommodation5,
        title: "Yurts",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Desert Oasis Retreat",
            peopleCapacity: "5 People",
            size: "40 sqm",
            wifi: "Yes",
            bedrooms: "2 bedrooms",
            reservationCost: "From $180 per night"
        },
        paragraphs: [
            "Experience the unique charm of staying in a Yurt, combining the comfort of modern amenities with the authenticity of traditional Mongolian nomadic shelters.",
            "Our yurts provide a cozy yet spacious setting for small groups or families, offering a peaceful escape while still being in close proximity to nature's wonders."
        ],
        gallery: [
            images.accommodation5Gallery1,
            images.accommodation5Gallery2
        ],
        features: [
            "Circular, spacious interiors with high ceilings",
            "Comfy bedding and traditional furnishings",
            "Private outdoor seating area",
            "Eco-friendly and sustainable design",
            "Heating and cooling options for comfort"
        ],
        facilities: [
            "Stunning desert and mountain views",
            "Access to guided cultural and nature tours",
            "Private outdoor fire pit for evening relaxation",
            "Nearby hiking and desert exploration trails",
            "Yoga and wellness retreats available",
            "Complimentary water and snacks",
            "Private parking near yurts",
            "Laundry services available",
            "Pet-friendly yurts upon request",
            "On-demand concierge service"
        ]
    },
    {
        id: 6,
        image: images.accommodation6,
        title: "RV Parks",
        content: "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Officia atque ipsam quia hic.",
        details: {
            location: "Coastal RV Park",
            peopleCapacity: "6 People",
            size: "60 sqm",
            wifi: "Yes",
            bedrooms: "3 bedrooms",
            reservationCost: "From $90 per night"
        },
        paragraphs: [
            "Enjoy the flexibility and comfort of our RV Park Accommodation, perfect for travelers seeking a unique experience with the freedom of your own vehicle.",
            "Our RV parks offer spacious spots with convenient amenities, allowing you to explore nature while staying close to modern conveniences, making it ideal for families and groups."
        ],
        gallery: [
            images.accommodation6Gallery1,
            images.accommodation6Gallery2
        ],
        features: [
            "Full hookup sites with water, electricity, and sewage",
            "Flat, level parking spots with plenty of space",
            "Private picnic areas with tables and grills",
            "Access to clean restroom and shower facilities",
            "Pet-friendly areas"
        ],
        facilities: [
            "On-site convenience store for necessities",
            "Access to local beaches and hiking trails",
            "24/7 security and gated access",
            "Wi-Fi and cable TV connections available",
            "Laundry facilities on-site",
            "Shuttle service to nearby attractions",
            "Clubhouse with lounge areas",
            "Outdoor recreation and sports facilities",
            "Waste disposal stations",
            "Tour and sightseeing packages available"
        ]
    }

];

export default accommodations;